import $ from 'jquery/src/jquery';
import {getUrlWithSerializedForm} from "./functions";

export default () => {
    const nodeSelectors = {
        container: '[js-news-filters="container"]',
        form: '[js-news-filters="form"]',
        formInput: '[js-news-filters="form-input"]',
        formResponse: '[js-news-filters="form-response"]',
        loadMoreButton: '[js-news-filters="load-more-button"]',
        pageInput: '[js-news-filters="page-input"]',
        isLoadMore: '[js-news-filters="is-load-more"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        initFilters()
    }

    function initFilters() {
        //On inputs change
        $(nodeSelectors.formInput).on('change', function (e) {
            resetPageNumber()
            submitForm()
            $(nodeSelectors.isLoadMore).val("0")
        })

        //On form submit
        $(nodeSelectors.form).on('submit', function(e) {
            e.preventDefault()
            submitForm()
        });

        //On load more click
        $(nodeSelectors.loadMoreButton).on('click', function(){
            let tmp = parseInt($(nodeSelectors.pageInput).val())
            tmp++
            $(nodeSelectors.pageInput).val(tmp)
            $(nodeSelectors.isLoadMore).val("1")
            filterPosts(true)
        });
    }

    function submitForm() {
        setTimeout(function () {
            filterPosts();
        }, 10)
    }

    function filterPosts( loadMore = false ) {
        if( !loadMore ) {
            $(nodeSelectors.formResponse).addClass("loading")
        }

        $.ajax({
            url: siteData.site_url+"/wp-admin/admin-ajax.php",
            data: $(nodeSelectors.form).serialize(),
            type: "GET",
            beforeSend: function (xhr) {},
            success: function (data) {
                let objData = JSON.parse(data);

                if( !objData.next_page_posts ) {
                    hideLoadMoreBtn();
                } else {
                    showLoadMoreBtn();
                }

                if( loadMore ) {
                    document.querySelector(nodeSelectors.formResponse).innerHTML += objData.html
                } else {
                    resetPageNumber();
                    $(nodeSelectors.formResponse).html(objData.html)
                }
            },
            complete: function (data) {
                $(nodeSelectors.formResponse).removeClass("loading");

                if( loadMore ) { $('.newly-loaded-project').slideDown(250); }

                history.pushState(null, null, getUrlWithSerializedForm($(nodeSelectors.form)))
            },
        });
    }

    function hideLoadMoreBtn() {
        $(nodeSelectors.loadMoreButton).parent().slideUp()
    }

    function showLoadMoreBtn() {
        $(nodeSelectors.loadMoreButton).parent().slideDown()
    }

    function resetPageNumber() {
        $(nodeSelectors.pageInput).val('1')
    }

    return Object.freeze({
        init,
    })
}